// extracted by mini-css-extract-plugin
export default {"send-tips":"styles_send-tips__ElDfu","send-tips-icon":"styles_send-tips-icon__GqF2J","badge-wrapper":"styles_badge-wrapper__VmeGS"};